// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"80":"9284e8efe7d5792e2a80","115":"bf0787f5de280b0a7016","678":"65a53b01690911e41be7","932":"94cd813255f15ef81e3f"}[chunkId] + ".css";
};